import RulesView from "@/modules/rules/views/RulesView.vue";

export const RulesRoutes = [
    {
        path: '/rules',
        component: RulesView,
    }
];
